import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { AccessControlService } from '../services/access-control.service';

@Pipe({
  name: 'access',
  standalone: true,
})
export class AccessPipe implements PipeTransform {

  constructor(private accessControlService: AccessControlService) {
  }

  transform(value: { data: { roles: Array<string> } }): Observable<boolean> {
    return this.accessControlService.hasAccess(value);
  }

}
